import template from './create-interval-modal.tpl.html'
import moment from 'moment'

class CreateIntervalModalController {
  constructor ($scope) {
    'ngInject'
    this._$scope = $scope
    this.localInterval = null
    this.playlistSearch = ''
  }

  $onChanges (changes) {
    if (changes.interval && this.interval) {
      this.localInterval = angular.copy(this.interval)
      this.playlistSearch = ''
    }
  }

  formatDateTime (date, format) {
    if (!date) return ''
    return moment(date).format(format)
  }

  create () {
    this.onCreate({ $interval: this.localInterval })
  }

  cancel () {
    this.onClose()
  }
}

export const CreateIntervalModalComponent = {
  template,
  controller: CreateIntervalModalController,
  bindings: {
    show: '<',
    interval: '<',
    availablePlaylists: '<',
    onClose: '&',
    onCreate: '&'
  }
}
